module.exports = __webpack_public_path__ + "img/accessory_pants_01.d5b08aa4.svg";